import axios from 'axios';
import {GET_ERRORS,
    GET_CURRENT_SCHEDULE,
    GET_COMPLETED_SCHEDULE,
    GET_AVAILABILITY,
    ADD_AVAILABILITY,
    REMOVE_AVAILABILITY,
    UPDATE_NOTE} from "./types";

//
export const getSchedule = userData => dispatch => {
    axios
        .get(`${process.env.REACT_APP_API_URL_BASE}/api/installer/listInstallerBookings`, {params:userData})
        .then( res => {
            if (res.data.error) {
                dispatch(setErrors(res.data.error));
            } else {
                dispatch(setCurrentSchedule(res.data));
            }
        })
        .catch(err => {
            dispatch({
                type: GET_ERRORS,
                payload: err
            })
        });
}

export const getCompletedSchedule = userData => dispatch => {
    axios
        .get(`${process.env.REACT_APP_API_URL_BASE}/api/installer/listInstallerBookings`, {params:userData})
        .then( res => {
            if (res.data.error) {
                dispatch(setErrors(res.data.error));
            } else {
                dispatch(setCompletedSchedule(res.data));
            }
        })
        .catch(err => {
            dispatch({
                type: GET_ERRORS,
                payload: err
            })
        });
}

export const getAvailability = userData => dispatch => {
    axios
        .get(`${process.env.REACT_APP_API_URL_BASE}/api/installer/getAvailability`, {params:userData})
        .then( res => {
            if (res.data.error) {
                dispatch(setErrors(res.data.error));
            } else {
                dispatch(setAvailability(res.data));
            }
        })
        .catch(err => {
            dispatch({
                type: GET_ERRORS,
                payload: err
            })
        });
}

export const addAvailabilitySlot = userData => dispatch => {
    axios
        .get(`${process.env.REACT_APP_API_URL_BASE}/api/installer/addAvailabilitySlot`, {params:userData})
        .then(res => {
            dispatch(addAvailability(res.data));
        })
        .catch(err => {
            dispatch({
                type: GET_ERRORS,
                payload: err
            })
        });
}

export const removeAvailabilitySlot = slotData => dispatch => {
    axios
        .get(`${process.env.REACT_APP_API_URL_BASE}/api/installer/removeAvailabilitySlot`, {params: slotData})
        .then( res => {
            dispatch(removeAvailability(slotData));
        })
        .catch(err =>{
            dispatch({
                type: GET_ERRORS,
                payload: err
            })
        });
}

export const updateNote = noteData => dispatch => {
    axios
        .get(`${process.env.REACT_APP_API_URL_BASE}/api/installer/updateAppointmentNote`, {params:noteData})
        .then(res => {
            dispatch({
                type: UPDATE_NOTE,
                payload: res.data
            });
        })
        .catch(err => {
            dispatch({
                type: GET_ERRORS,
                payload: err
            })
        });
}

// Set logged in user
export const setCurrentSchedule = schedule => {
    return {
        type: GET_CURRENT_SCHEDULE,
        payload: schedule
    };
};

export const setCompletedSchedule = schedule => {
    return {
        type: GET_COMPLETED_SCHEDULE,
        payload: schedule
    };
};

export const setAvailability = availability => {
    return {
        type: GET_AVAILABILITY,
        payload: availability
    };
};

export const addAvailability = availability => {
    return {
        type: ADD_AVAILABILITY,
        payload: availability
    };
};

const removeAvailability = removal => {
    return {
        type: REMOVE_AVAILABILITY,
        payload: removal
    };
};

export const setErrors = err => {
    return {
        type: GET_ERRORS,
        payload: err
    };
}



// WEBPACK FOOTER //
// ./src/actions/scheduleActions.jsx